import React from "react";
import styled from "styled-components";

const Container = styled.div`
  margin: 12rem 2rem 7rem 2rem;
`;

const Privacy = () => {
  return (
    <Container>
      <h2>Privacy Policy</h2>
      <p>
        Personal data (usually referred to just as "data" below) will only be
        processed by us to the extent necessary and for the purpose of providing
        a functional and user-friendly website, including its contents, and the
        services offered there.
      </p>
      <p>
        Per Art. 4 No. 1 of Regulation (EU) 2016/679, i.e. the General Data
        Protection Regulation (hereinafter referred to as the "GDPR"),
        "processing" refers to any operation or set of operations such as
        collection, recording, organization, structuring, storage, adaptation,
        alteration, retrieval, consultation, use, disclosure by transmission,
        dissemination, or otherwise making available, alignment, or combination,
        restriction, erasure, or destruction performed on personal data, whether
        by automated means or not.
      </p>
      <p>
        The following privacy policy is intended to inform you in particular
        about the type, scope, purpose, duration, and legal basis for the
        processing of such data either under our own control or in conjunction
        with others. We also inform you below about the third-party components
        we use to optimize our website and improve the user experience which may
        result in said third parties also processing data they collect and
        control.
      </p>
      <p>Our privacy policy is structured as follows:</p>
      <p>I. Information about us as controllers of your data</p>
      <p>II. The rights of users and data subjects</p>
      <p>III. Information about the data processing</p>
      <p>
        I. Information about us as controllers of your data The party
        responsible for this website (the "controller") for purposes of data
        protection law is:
      </p>
      <p>TóMSTUND UG (haftungsbeschränkt)</p>
      <p>Chausseestraße 15</p>
      <p>15345 Rüdersdorf bei Berlin</p>
      <p>Germany</p>
      <p>contact@tomstund.com</p>
      <p>www.sampell.com</p>
      <p>The controller's data protection officer is:</p>
      <p>Sonja Mönkemeyer</p>
      <p>E-Mail:</p>
      <p>somonk@tomstund.com</p>
      II. The rights of users and data subjects With regard to the data
      processing to be described in more detail below, users and data subjects
      have the right to confirmation of whether data concerning them is being
      processed, information about the data being processed, further information
      about the nature of the data processing, and copies of the data (cf. also
      Art. 15 GDPR); to correct or complete incorrect or incomplete data (cf.
      also Art. 16 GDPR); to the immediate deletion of data concerning them (cf.
      also Art. 17 DSGVO), or, alternatively, if further processing is necessary
      as stipulated in Art. 17 Para. 3 GDPR, to restrict said processing per
      Art. 18 GDPR; to receive copies of the data concerning them and/or
      provided by them and to have the same transmitted to other
      providers/controllers (cf. also Art. 20 GDPR); to file complaints with the
      supervisory authority if they believe that data concerning them is being
      processed by the controller in breach of data protection provisions (see
      also Art. 77 GDPR). In addition, the controller is obliged to inform all
      recipients to whom it discloses data of any such corrections, deletions,
      or restrictions placed on processing the same per Art. 16, 17 Para. 1, 18
      GDPR. However, this obligation does not apply if such notification is
      impossible or involves a disproportionate effort. Nevertheless, users have
      a right to information about these recipients. Likewise, under Art. 21
      GDPR, users and data subjects have the right to object to the controller's
      future processing of their data pursuant to Art. 6 Para. 1 lit. f) GDPR.
      In particular, an objection to data processing for the purpose of direct
      advertising is permissible. III. Information about the data processing
      Your data processed when using our website will be deleted or blocked as
      soon as the purpose for its storage ceases to apply, provided the deletion
      of the same is not in breach of any statutory storage obligations or
      unless otherwise stipulated below. Server data For technical reasons, the
      following data sent by your internet browser to us or to our server
      provider will be collected, especially to ensure a secure and stable
      website: These server log files record the type and version of your
      browser, operating system, the website from which you came (referrer URL),
      the webpages on our site visited, the date and time of your visit, as well
      as the IP address from which you visited our site. The data thus collected
      will be temporarily stored, but not in association with any other of your
      data. The basis for this storage is Art. 6 Para. 1 lit. f) GDPR. Our
      legitimate interest lies in the improvement, stability, functionality, and
      security of our website. The data will be deleted within no more than
      seven days, unless continued storage is required for evidentiary purposes.
      In which case, all or part of the data will be excluded from deletion
      until the investigation of the relevant incident is finally resolved.
      Cookies a) Session cookies We use cookies on our website. Cookies are
      small text files or other storage technologies stored on your computer by
      your browser. These cookies process certain specific information about
      you, such as your browser, location data, or IP address. This processing
      makes our website more user-friendly, efficient, and secure, allowing us,
      for example, to display our website in different languages or to offer a
      shopping cart function. The legal basis for such processing is Art. 6
      Para. 1 lit. b) GDPR, insofar as these cookies are used to collect data to
      initiate or process contractual relationships. If the processing does not
      serve to initiate or process a contract, our legitimate interest lies in
      improving the functionality of our website. The legal basis is then Art. 6
      Para. 1 lit. f) GDPR. When you close your browser, these session cookies
      are deleted. b) Third-party cookies If necessary, our website may also use
      cookies from companies with whom we cooperate for the purpose of
      advertising, analyzing, or improving the features of our website. Please
      refer to the following information for details, in particular for the
      legal basis and purpose of such third-party collection and processing of
      data collected through cookies. c) Disabling cookies You can refuse the
      use of cookies by changing the settings on your browser. Likewise, you can
      use the browser to delete cookies that have already been stored. However,
      the steps and measures required vary, depending on the browser you use. If
      you have any questions, please use the help function or consult the
      documentation for your browser or contact its maker for support. Browser
      settings cannot prevent so-called flash cookies from being set. Instead,
      you will need to change the setting of your Flash player. The steps and
      measures required for this also depend on the Flash player you are using.
      If you have any questions, please use the help function or consult the
      documentation for your Flash player or contact its maker for support. If
      you prevent or restrict the installation of cookies, not all of the
      functions on our site may be fully usable. Order processing The data you
      submit when ordering goods and/or services from us will have to be
      processed in order to fulfill your order. Please note that orders cannot
      be processed without providing this data. The legal basis for this
      processing is Art. 6 Para. 1 lit. b) GDPR. After your order has been
      completed, your personal data will be deleted, but only after the
      retention periods required by tax and commercial law. In order to process
      your order, we will share your data with the shipping company responsible
      for delivery to the extent required to deliver your order and/or with the
      payment service provider to the extent required to process your payment.
      The legal basis for the transfer of this data is Art. 6 Para. 1 lit. b)
      GDPR. Customer account/registration If you create a customer account with
      us via our website, we will use the data you entered during registration
      (e.g. your name, your address, or your email address) exclusively for
      services leading up to your potential placement of an order or entering
      some other contractual relationship with us, to fulfill such orders or
      contracts, and to provide customer care (e.g. to provide you with an
      overview of your previous orders or to be able to offer you a wishlist
      function). We also store your IP address and the date and time of your
      registration. This data will not be transferred to third parties. During
      the registration process, your consent will be obtained for this
      processing of your data, with reference made to this privacy policy. The
      data collected by us will be used exclusively to provide your customer
      account. If you give your consent to this processing, Art. 6 Para. 1 lit.
      a) GDPR is the legal basis for this processing. If the opening of the
      customer account is also intended to lead to the initiation of a
      contractual relationship with us or to fulfill an existing contract with
      us, the legal basis for this processing is also Art. 6 Para. 1 lit. b)
      GDPR. You may revoke your prior consent to the processing of your personal
      data at any time under Art. 7 Para. 3 GDPR with future effect. All you
      have to do is inform us that you are revoking your consent. The data
      previously collected will then be deleted as soon as processing is no
      longer necessary. However, we must observe any retention periods required
      under tax and commercial law. Newsletter If you register for our free
      newsletter, the data requested from you for this purpose, i.e. your email
      address and, optionally, your name and address, will be sent to us. We
      also store the IP address of your computer and the date and time of your
      registration. During the registration process, we will obtain your consent
      to receive this newsletter and the type of content it will offer, with
      reference made to this privacy policy. The data collected will be used
      exclusively to send the newsletter and will not be passed on to third
      parties. The legal basis for this is Art. 6 Para. 1 lit. a) GDPR. You may
      revoke your prior consent to receive this newsletter under Art. 7 Para. 3
      GDPR with future effect. All you have to do is inform us that you are
      revoking your consent or click on the unsubscribe link contained in each
      newsletter. Contact If you contact us via email or the contact form, the
      data you provide will be used for the purpose of processing your request.
      We must have this data in order to process and answer your inquiry;
      otherwise we will not be able to answer it in full or at all. The legal
      basis for this data processing is Art. 6 Para. 1 lit. b) GDPR. Your data
      will be deleted once we have fully answered your inquiry and there is no
      further legal obligation to store your data, such as if an order or
      contract resulted therefrom. User posts, comments, and ratings We offer
      you the opportunity to post questions, answers, opinions, and ratings on
      our website, hereinafter referred to jointly as "posts." If you make use
      of this opportunity, we will process and publish your post, the date and
      time you submitted it, and any pseudonym you may have used. The legal
      basis for this is Art. 6 Para. 1 lit. a) GDPR. You may revoke your prior
      consent under Art. 7 Para. 3 GDPR with future effect. All you have to do
      is inform us that you are revoking your consent. In addition, we will also
      process your IP address and email address. The IP address is processed
      because we might have a legitimate interest in taking or supporting
      further action if your post infringes the rights of third parties and/or
      is otherwise unlawful. In this case, the legal basis is Art. 6 Para. 1
      lit. f) GDPR. Our legitimate interest lies in any legal defense we may
      have to mount. Google Analytics We use Google Analytics on our website.
      This is a web analytics service provided by Google Inc., 1600 Amphitheatre
      Parkway, Mountain View, CA 94043 (hereinafter: Google). Through
      certification according to the EU-US Privacy Shield
      https://www.privacyshield.gov/participant?id=a2zt000000001L5AAI&status=Active
      Google guarantees that it will follow the EU's data protection regulations
      when processing data in the United States. The Google Analytics service is
      used to analyze how our website is used. The legal basis is Art. 6 Para. 1
      lit. f) GDPR. Our legitimate interest lies in the analysis, optimization,
      and economic operation of our site. Usage and user-related information,
      such as IP address, place, time, or frequency of your visits to our
      website will be transmitted to a Google server in the United States and
      stored there. However, we use Google Analytics with the so-called
      anonymization function, whereby Google truncates the IP address within the
      EU or the EEA before it is transmitted to the US. The data collected in
      this way is in turn used by Google to provide us with an evaluation of
      visits to our website and what visitors do once there. This data can also
      be used to provide other services related to the use of our website and of
      the internet in general. Google states that it will not connect your IP
      address to other data. In addition, Google provides further information
      with regard to its data protection practices at
      https://www.google.com/intl/de/policies/privacy/partners, including
      options you can exercise to prevent such use of your data. In addition,
      Google offers an opt-out add-on at
      https://tools.google.com/dlpage/gaoptout?hl=en in addition with further
      information. This add-on can be installed on the most popular browsers and
      offers you further control over the data that Google collects when you
      visit our website. The add-on informs Google Analytics' JavaScript (ga.js)
      that no information about the website visit should be transmitted to
      Google Analytics. However, this does not prevent information from being
      transmitted to us or to other web analytics services we may use as
      detailed herein. Google+ plug-in We use the plug-in of the Google+ social
      network on our website. Google+ is an online service provided by Google
      Inc., 1600 Amphitheatre Parkway, Mountain View, CA 94043 (hereinafter:
      Google). Through certification according to the EU-US Privacy Shield
      https://www.privacyshield.gov/participant?id=a2zt000000001L5AAI&status=Active
      Google guarantees that it will follow the EU's data protection regulations
      when processing data in the United States. The legal basis is Art. 6 Para.
      1 lit. f) GDPR. Our legitimate interest lies in improving the quality of
      our website. Further information about the possible plug-ins and their
      respective functions is available from Google at
      https://developers.google.com/+/web/ If the plug-in is stored on one of
      the pages you visit on our website, your browser will download an icon for
      the plug-in from Google's servers in the USA. For technical reasons, it is
      necessary for Google to process your IP address. In addition, the date and
      time of your visit to our website will also be recorded. If you are logged
      in to Google while visiting one of our plugged-in websites, the
      information collected by the plug-in from your specific visit will be
      recognized by Google. The information collected may then be assigned to
      your personal account at Google. If, for example, you use the +1 button,
      this information will be stored in your Google Account and may be
      published on the Google platform. To prevent this, you must either log out
      of Google before visiting our site or make the appropriate settings in
      your Google account. Further information about the collection and use of
      data as well as your rights and protection options in Google's privacy
      policy found at https://policies.google.com/privacy Google-Maps Our
      website uses Google Maps to display our location and to provide
      directions. This is a service provided by Google Inc., 1600 Amphitheatre
      Parkway, Mountain View, CA 94043 (hereinafter: Google). Through
      certification according to the EU-US Privacy Shield
      https://www.privacyshield.gov/participant?id=a2zt000000001L5AAI&status=Active
      Google guarantees that it will follow the EU's data protection regulations
      when processing data in the United States. To enable the display of
      certain fonts on our website, a connection to the Google server in the USA
      is established whenever our website is accessed. If you access the Google
      Maps components integrated into our website, Google will store a cookie on
      your device via your browser. Your user settings and data are processed to
      display our location and create a route description. We cannot prevent
      Google from using servers in the USA. The legal basis is Art. 6 Para. 1
      lit. f) GDPR. Our legitimate interest lies in optimizing the functionality
      of our website. By connecting to Google in this way, Google can determine
      from which website your request has been sent and to which IP address the
      directions are transmitted. If you do not agree to this processing, you
      have the option of preventing the installation of cookies by making the
      appropriate settings in your browser. Further details can be found in the
      section about cookies above. In addition, the use of Google Maps and the
      information obtained via Google Maps is governed by the Google Terms of
      Use https://policies.google.com/terms?gl=DE&hl=en and the Terms and
      Conditions for Google Maps
      https://www.google.com/intl/de_de/help/terms_maps.html. Google also offers
      further information at https://adssettings.google.com/authenticated
      https://policies.google.com/privacy Google reCAPTCHA Our website uses
      Google reCAPTCHA to check and prevent automated servers ("bots") from
      accessing and interacting with our website. This is a service provided by
      Google Inc., 1600 Amphitheatre Parkway, Mountain View, CA 94043
      (hereinafter: Google). Through certification according to the EU-US
      Privacy Shield
      https://www.privacyshield.gov/participant?id=a2zt000000001L5AAI&status=Active
      Google guarantees that it will follow the EU's data protection regulations
      when processing data in the United States. This service allows Google to
      determine from which website your request has been sent and from which IP
      address the reCAPTCHA input box has been used. In addition to your IP
      address, Google may collect other information necessary to provide and
      guarantee this service. The legal basis is Art. 6 Para. 1 lit. f) GDPR.
      Our legitimate interest lies in the security of our website and in the
      prevention of unwanted, automated access in the form of spam or similar.
      Google offers detailed information at https://policies.google.com/privacy
      concerning the general handling of your user data. Google Fonts Our
      website uses Google Fonts to display external fonts. This is a service
      provided by Google Inc., 1600 Amphitheatre Parkway, Mountain View, CA
      94043 (hereinafter: Google). Through certification according to the EU-US
      Privacy Shield
      https://www.privacyshield.gov/participant?id=a2zt000000001L5AAI&status=Active
      Google guarantees that it will follow the EU's data protection regulations
      when processing data in the United States. To enable the display of
      certain fonts on our website, a connection to the Google server in the USA
      is established whenever our website is accessed. The legal basis is Art. 6
      Para. 1 lit. f) GDPR. Our legitimate interest lies in the optimization and
      economic operation of our site. When you access our site, a connection to
      Google is established from which Google can identify the site from which
      your request has been sent and to which IP address the fonts are being
      transmitted for display. Google offers detailed information at
      https://adssettings.google.com/authenticated
      https://policies.google.com/privacy in particular on options for
      preventing the use of data. Facebook plug-in Our website uses the plug-in
      of the Facebook social network. Facebook.com is a service provided by
      Facebook Inc., 1601 S. California Ave, Palo Alto, CA 94304, USA. In the
      EU, this service is also operated by Facebook Ireland Limited, 4 Grand
      Canal Square, Dublin 2, Ireland, hereinafter both referred to as
      "Facebook." Through certification according to the EU-US Privacy Shield
      https://www.privacyshield.gov/participant?id=a2zt0000000GnywAAC&status=Active
      Facebook guarantees that it will follow the EU's data protection
      regulations when processing data in the United States. The legal basis is
      Art. 6 Para. 1 lit. f) GDPR. Our legitimate interest lies in improving the
      quality of our website. Further information about the possible plug-ins
      and their respective functions is available from Facebook at
      https://developers.facebook.com/docs/plugins/ If the plug-in is stored on
      one of the pages you visit on our website, your browser will download an
      icon for the plug-in from Facebook's servers in the USA. For technical
      reasons, it is necessary for Facebook to process your IP address. In
      addition, the date and time of your visit to our website will also be
      recorded. If you are logged in to Facebook while visiting one of our
      plugged-in websites, the information collected by the plug-in from your
      specific visit will be recognized by Facebook. The information collected
      may then be assigned to your personal account at Facebook. If, for
      example, you use the Facebook Like button, this information will be stored
      in your Facebook account and published on the Facebook platform. If you
      want to prevent this, you must either log out of Facebook before visiting
      our website or use an add-on for your browser to prevent the Facebook
      plug-in from loading. Further information about the collection and use of
      data as well as your rights and protection options in Facebook's privacy
      policy found at https://www.facebook.com/policy.php Twitter plug-in Our
      website uses the plug-in of the Twitter social network. The Twitter
      service is operated by Twitter Inc., 795 Folsom St., Suite 600, San
      Francisco, CA 94107, USA ("Twitter"). Through certification according to
      the EU-US Privacy Shield
      https://www.privacyshield.gov/participant?id=a2zt0000000TORzAAO&status=Active
      Twitter guarantees that it will follow the EU's data protection
      regulations when processing data in the United States. The legal basis is
      Art. 6 Para. 1 lit. f) GDPR. Our legitimate interest lies in improving the
      quality of our website. If the plug-in is stored on one of the pages you
      visit on our website, your browser will download an icon for the plug-in
      from Twitter's servers in the USA. For technical reasons, it is necessary
      for Twitter to process your IP address. In addition, the date and time of
      your visit to our website will also be recorded. If you are logged in to
      Twitter while visiting one of our plugged-in websites, the information
      collected by the plug-in from your specific visit will be recognized by
      Twitter. The information collected may then be assigned to your personal
      account at Twitter. If, for example, you use the Twitter Tweet button,
      this information will be stored in your Twitter account and may be
      published on the Twitter platform. To prevent this, you must either log
      out of Twitter before visiting our site or make the appropriate settings
      in your Twitter account. Further information about the collection and use
      of data as well as your rights and protection options in Twitter's privacy
      policy found at https://twitter.com/privacy YouTube We use YouTube on our
      website. This is a video portal operated by YouTube LLC, 901 Cherry Ave,
      94066 San Bruno, CA, USA, hereinafter referred to as "YouTube". YouTube is
      a subsidiary of Google LLC, 1600 Amphitheatre Parkway, Mountain View, CA
      94043 USA, hereinafter referred to as "Google". Through certification
      according to the EU-US Privacy Shield
      https://www.privacyshield.gov/participant?id=a2zt000000001L5AAI&status=Active
      Google and its subsidiary YouTube guarantee that they will follow the EU's
      data protection regulations when processing data in the United States. We
      use YouTube in its advanced privacy mode to show you videos. The legal
      basis is Art. 6 Para. 1 lit. f) GDPR. Our legitimate interest lies in
      improving the quality of our website. According to YouTube, the advanced
      privacy mode means that the data specified below will only be transmitted
      to the YouTube server if you actually start a video. Without this mode, a
      connection to the YouTube server in the USA will be established as soon as
      you access any of our webpages on which a YouTube video is embedded. This
      connection is required in order to be able to display the respective video
      on our website within your browser. YouTube will record and process at a
      minimum your IP address, the date and time the video was displayed, as
      well as the website you visited. In addition, a connection to the
      DoubleClick advertising network of Google is established. If you are
      logged in to YouTube when you access our site, YouTube will assign the
      connection information to your YouTube account. To prevent this, you must
      either log out of YouTube before visiting our site or make the appropriate
      settings in your YouTube account. For the purpose of functionality and
      analysis of usage behavior, YouTube permanently stores cookies on your
      device via your browser. If you do not agree to this processing, you have
      the option of preventing the installation of cookies by making the
      appropriate settings in your browser. Further details can be found in the
      section about cookies above. Further information about the collection and
      use of data as well as your rights and protection options in Google's
      privacy policy found at https://policies.google.com/privacy Shariff social
      media buttons Our website uses the plug-ins of the following social
      networks. To integrate these plug-ins, we use the Shariff plug-in. The
      legal basis is Art. 6 Para. 1 lit. f) GDPR. Our legitimate interest lies
      in improving the quality of our website. Shariff is an open source program
      developed by c't and heise. By integrating this plug-in, linked graphics
      prevent the following social network plug-ins from automatically
      establishing a connection to the respective social networks server when
      you visit website(s) on which the plug-ins are integrated. Only if you
      click on one of these linked graphics will you be forwarded to the service
      of the respective social network. Only then will information about your
      use of our site be recorded by the respective social network. This
      information may include your IP address, the date and time you visited our
      site, as well as the pages you viewed. If you are logged in to one of the
      social network services while visiting one of our plugged-in websites, the
      information collected by the plug-in from your specific visit will be
      recognized by the provider of that social network and assigned to your
      personal user account there and/or publish information about your
      interaction with our site there. If, for example, you use the a share
      button for the social network, this information may be stored in your user
      account there and published on the platform of the respective social
      network provider. To prevent this, you must either log out of the social
      network before clicking the graphic or make the appropriate settings in
      your social network account. Further information about Shariff is
      available at
      http://www.heise.de/ct/artikel/Shariff-Social-Media-Buttons-mit-Datenschutz-2467514.html
      The following social networks are integrated into our website: Google+
      operated by Google LLC, 1600 Amphitheatre Parkway, Mountain View,
      California, 94043, USA. Privacy information is available at
      https://policies.google.com/privacy Through certification according to the
      EU-US Privacy Shield
      https://www.privacyshield.gov/participant?id=a2zt000000001L5AAI&status=Active
      Google guarantees that it will follow the EU's data protection regulations
      when processing data in the United States. Facebook operated by Facebook
      Inc, 1601 S. California Ave, Palo Alto, CA 94304, USA, operated within the
      EU by Facebook Ireland Limited, 4 Grand Canal Square, Dublin 2, Ireland.
      Privacy information can be found at https://www.facebook.com/policy.php
      Through certification according to the EU-US Privacy Shield
      https://www.privacyshield.gov/participant?id=a2zt0000000GnywAAC&status=Active
      Facebook guarantees that it will follow the EU's data protection
      regulations when processing data in the United States. Twitter operated by
      Twitter Inc, 795 Folsom St., Suite 600, San Francisco, CA 94107, USA.
      Privacy information can be found at https://twitter.com/privacy Through
      certification according to the EU-US Privacy Shield
      https://www.privacyshield.gov/participant?id=a2zt0000000TORzAAO&status=Active
      Twitter guarantees that it will follow the EU's data protection
      regulations when processing data in the United States. Google AdWords with
      Conversion Tracking Our website uses Google AdWords and conversion
      tracking. This is a service provided by Google Inc., 1600 Amphitheatre
      Parkway, Mountain View, CA 94043 (hereinafter: Google). Through
      certification according to the EU-US Privacy Shield
      https://www.privacyshield.gov/participant?id=a2zt000000001L5AAI&status=Active
      Google guarantees that it will follow the EU's data protection regulations
      when processing data in the United States. We use conversion tracking to
      provide targeted promotion of our site. The legal basis is Art. 6 Para. 1
      lit. f) GDPR. Our legitimate interest lies in the analysis, optimization,
      and economic operation of our site. If you click on an ad placed by
      Google, the conversion tracking we use stores a cookie on your device.
      These so-called conversion cookies expire after 30 days and do not
      otherwise identify you personally. If the cookie is still valid and you
      visit a specific page of our website, both we and Google can evaluate that
      you clicked on one of our ads placed on Google and that you were then
      forwarded to our website. The data collected in this way is in turn used
      by Google to provide us with an evaluation of visits to our website and
      what visitors do once there. In addition, we receive information about the
      number of users who clicked on our advertisement(s) as well as about the
      pages on our site that are subsequently visited. Neither we nor third
      parties who also use Google AdWords will be able to identify you from this
      conversion tracking. You can also prevent or restrict the installation of
      cookies by making the appropriate settings in your browser. Likewise, you
      can use the browser to delete cookies that have already been stored.
      However, the steps and measures required vary, depending on the browser
      you use. If you have any questions, please use the help function or
      consult the documentation for your browser or contact its maker for
      support. In addition, Google provides further information with regard to
      its data protection practices at
      https://services.google.com/sitestats/de.html
      http://www.google.com/policies/technologies/ads/
      http://www.google.de/policies/privacy/ in particular information on how
      you can prevent the use of your data. Google AdSense We use Google AdSense
      on our website to integrate advertisements. This is a service provided by
      Google Inc., 1600 Amphitheatre Parkway, Mountain View, CA 94043
      (hereinafter: Google). Through certification according to the EU-US
      Privacy Shield
      https://www.privacyshield.gov/participant?id=a2zt000000001L5AAI&status=Active
      Google guarantees that it will follow the EU's data protection regulations
      when processing data in the United States. Google AdSense stores cookies
      and web beacons on your device via your browser. This enables Google to
      analyze how you use our website. In addition to your IP address and the
      advertising formats displayed, the information thus collected will be
      transmitted to Google in the USA and stored there. Google may also share
      this information with third parties. Google states that it will not
      connect your IP address to other data. The legal basis is Art. 6 Para. 1
      lit. f) GDPR. Our legitimate interest lies in the analysis, optimization,
      and economic operation of our site. If you do not agree to this
      processing, you have the option of preventing the installation of cookies
      by making the appropriate settings in your browser. Further details can be
      found in the section about cookies above. In addition, Google offers an
      opt-out add-on at https://policies.google.com/privacy
      https://adssettings.google.com/authenticated in particular on options for
      preventing the use of data. Online job applications / publication of job
      advertisements We offer you the opportunity to apply for jobs with our
      company via our website. In the case of these digital applications, we
      collect your application data electronically in order to process your
      application. The legal basis for this processing is §26 Para. 1 S. 1 BDSG
      in conjunction with Art. 88 Para. 1 GDPR. If you are hired as a result of
      the application process, we will store the data you provide during the
      application process in your personnel file for the purpose of the usual
      organizational and administrative process, naturally in compliance with
      further legal obligations. The legal basis for this processing is §26
      Para. 1 S. 1 BDSG in conjunction with Art. 88 Para. 1 GDPR. If we do not
      hire you, we will automatically delete the data submitted to us two months
      after the final decision is made. We will not delete the data, however, if
      we must store the data for legal reasons such as evidence of equal
      treatment of applicants, until any legal action is concluded, or four
      months. In this case, the legal basis is Art. 6 Para. 1 lit. f) GDPR and
      §24 Para. 1 No. 2 BDSG. Our legitimate interest lies in any legal defense
      we may have to mount . If you expressly consent to a longer storage of
      your data, e.g. for your inclusion in a database of applicants or
      interested parties, the data will be processed further on the basis of
      your consent. The legal basis is then Art. 6 Para. 1 lit. a) GDPR. You may
      withdraw your consent at any time with future effect per Art. 7 Para. 3
      GDPR with future effect.
      <p>Model Data Protection Statement for Anwaltskanzlei Weiß & Partner</p>
      <a href="https://www.ratgeberrecht.eu/leistungen/muster-datenschutzerklaerung.html">
        https://www.ratgeberrecht.eu/leistungen/muster-datenschutzerklaerung.html
      </a>
    </Container>
  );
};

export default Privacy;



// WEBPACK FOOTER //
// ./src/components/Pages/Privacy/Privacy.js